var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 51,
    height: 51,
    rx: 25.5,
    stroke: "#E3E8E7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2346_7655)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.5 20.75V31.25C32.5 31.6478 32.342 32.0294 32.0607 32.3107C31.7794 32.592 31.3978 32.75 31 32.75H17.5C17.1022 32.75 16.7206 32.592 16.4393 32.3107C16.158 32.0294 16 31.6478 16 31.25V20.75C16 20.3522 16.158 19.9706 16.4393 19.6893C16.7206 19.408 17.1022 19.25 17.5 19.25H31C31.3978 19.25 31.7794 19.408 32.0607 19.6893C32.342 19.9706 32.5 20.3522 32.5 20.75ZM37.9375 20.7734C37.8317 20.7475 37.7216 20.7444 37.6145 20.7641C37.5073 20.7838 37.4056 20.826 37.3159 20.8878L34.1669 22.9869C34.1155 23.0211 34.0734 23.0676 34.0443 23.122C34.0152 23.1765 34 23.2373 34 23.2991V28.7009C34 28.7627 34.0152 28.8235 34.0443 28.878C34.0734 28.9324 34.1155 28.9789 34.1669 29.0131L37.3337 31.1244C37.4523 31.2034 37.5909 31.2471 37.7333 31.2503C37.8758 31.2534 38.0162 31.2159 38.1381 31.1422C38.2509 31.0705 38.3434 30.971 38.4068 30.8533C38.4702 30.7356 38.5022 30.6036 38.5 30.47V21.5C38.5001 21.3337 38.4449 21.172 38.343 21.0405C38.2412 20.909 38.0986 20.815 37.9375 20.7734Z",
    fill: "#329993"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2346_7655"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(14.5 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageVideo);
export default __webpack_public_path__ + "static/media/message-video.80f09d52dbb32946b7b523c390462188.svg";
export { ForwardRef as ReactComponent };